<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6>设备初始化白名单管理</h6>
        <button type="button" class="btn btn-primary btn-sm mb-0" @click="showAddModal = true">
          新增白名单
        </button>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                手机号
              </th>
              <th class="text-secondary opacity-7">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="2" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">加载中...</span>
                </div>
              </td>
            </tr>
            <tr v-else-if="phoneList.length === 0">
              <td colspan="2" class="text-center py-4 text-secondary">
                暂无白名单数据
              </td>
            </tr>
            <tr v-for="(phone, index) in phoneList" :key="index">
              <td>
                <p class="text-xs font-weight-bold mb-0 px-3 py-2">{{ phone }}</p>
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-danger font-weight-bold text-xs"
                  @click="confirmRemove(phone)"
                >
                  移除
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 新增白名单 Modal -->
    <div
      v-if="showAddModal"
      class="modal fade show"
      style="display: block; padding-right: 17px;"
      tabindex="-1"
      role="dialog"
      aria-hidden="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增白名单</h5>
          </div>
          <div class="modal-body">
            <input
              v-model="newPhone"
              type="text"
              class="form-control"
              placeholder="请输入手机号"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeAddModal">取消</button>
            <button type="button" class="btn btn-primary" :disabled="submitting" @click="submitAdd">
              {{ submitting ? '提交中...' : '确认' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAddModal" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import { getInitBoardUsers, addInitBoardUser, removeInitBoardUser } from "@/api/initboard"

export default {
  name: "initboard-whitelist",
  data() {
    return {
      phoneList: [],
      loading: false,
      showAddModal: false,
      newPhone: "",
      submitting: false,
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const resp = await getInitBoardUsers()
        if (resp.code === 0) {
          this.phoneList = resp.desc || []
        } else {
          this.phoneList = []
        }
      } catch (err) {
        console.error("获取白名单失败:", err)
        this.phoneList = []
      } finally {
        this.loading = false
      }
    },
    closeAddModal() {
      this.showAddModal = false
      this.newPhone = ""
    },
    async submitAdd() {
      if (!this.newPhone || !this.newPhone.trim()) {
        alert("请输入手机号")
        return
      }
      this.submitting = true
      try {
        const resp = await addInitBoardUser({ phone_no: this.newPhone.trim() })
        if (resp.code === 0) {
          alert("添加成功")
          this.closeAddModal()
          this.fetchList()
        } else {
          alert(resp.desc || "添加失败")
        }
      } catch (err) {
        alert("添加失败")
      } finally {
        this.submitting = false
      }
    },
    async confirmRemove(phone) {
      if (!confirm(`确定要移除 ${phone} 的白名单权限吗？`)) return
      try {
        const resp = await removeInitBoardUser({ phone_no: phone })
        if (resp.code === 0) {
          alert("移除成功")
          this.fetchList()
        } else {
          alert(resp.desc || "移除失败")
        }
      } catch (err) {
        alert("移除失败")
      }
    },
  },
}
</script>
